<template>
    <div class="service">
        <PageTitle title="产品展示"/>
        <section id="single_Service" class="sec-padding">
        	<div class="container">
        		<div class="row">
                    <!--侧边栏  -->
                    <PageAside :list="productColumns" :active="active" @tabClick="tabClick"/>
                    <!-- 列表区域 -->
        			<div class="col-lg-9 col-md-9">
                        <!-- 列表部分 -->
                        <List :data="productList" @itemClick="detail"/>
                        <!-- 分页 -->
                        <PagePagination v-if="productList.length>0" :total="productTotal" @page="initData"/>
                        <!-- 没有数据 -->
                        <div v-else class="text-center">暂无数据</div>
        			</div>
        		</div>
        	</div>
        </section>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex';
    import PageTitle from "@/components/common/PageTitle.vue";
    import PageAside from "@/components/common/PageAside.vue";
    import List from "@/components/product/List.vue";
    import PagePagination from "@/components/common/PagePagination.vue";
    import { getClassActive } from "@/assets/js/core.js";
    export default {
        name: "product",
        data(){
            return{
                active: 0
            }
        },
        mounted(){
            let { type, active } = this.columnClass || {};
            if(type == 'product'){
                this.active = getClassActive(this.productColumns,active);;
            }
            this.initData(1);
            this.setColumnClass();
        },
        methods:{
            tabClick(index){
                this.active = index;
                this.initData(1);
            },
            initData(page){
                let data = undefined;
                if(this.productColumns&&this.productColumns[this.active]){
                    let classId = this.productColumns[this.active].id;
                    data = "page="+page+"&classId="+classId;
                }
                this.getProductData(data);
            },
            detail(item){
                // let href = window.location.href.split("#")[0];
				// href += "#/productDetail/"+ item.id
				// window.open(href);
                this.$router.push({
					name: 'productDetail',
					params: {
						id: item.id
					}
				});
            },
            ...mapMutations(['setColumnClass']),
            ...mapActions(['getProductData'])
        },
        computed:{
            ...mapGetters(['productColumns','productList','productTotal','columnClass'])
        },
        components:{
            PageTitle,
            PageAside,
            List,
            PagePagination
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/product.vue